import React from 'react';

var Trolley = function Trolley(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.1 7.713L7.58 14.2c.106.468.523.8 1.003.8h8.436c.48 0 .896-.332 1.003-.8l.911-3.988a2.043 2.043 0 0 0-1.992-2.499H6.101zm0 0H4.843a1 1 0 0 1 0-2h12.1a4.043 4.043 0 0 1 3.94 4.944l-.91 3.99A3.029 3.029 0 0 1 17.018 17H8.583a3.029 3.029 0 0 1-2.953-2.355L3.025 3.223a1 1 0 0 1 1.95-.445l1.126 4.935zM17 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-8 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Trolley.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Trolley as icon };
export default iconHandler(Trolley);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Trolley.js
// module id = 629
// module chunks = 0